

module.exports = __webpack_require__.stylable.create(
    "Price402674458",
    {"classes":{"root":"Price402674458__root","wrapper":"Price402674458__wrapper","currency":"Price402674458__currency","price":"Price402674458__price"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "Price402674458",
    null
);
